import React from 'react';
import { ReactComponent as FullLogo } from 'img/logos/full-logo-wsfec-white.svg';
import { ReactComponent as FacebookIcon } from 'img/social/icon-facebook.svg';
import { ReactComponent as XIcon } from 'img/social/icon-x.svg';
import { ReactComponent as LinkedInIcon } from 'img/social/icon-linkedin.svg';
import { ReactComponent as InstagramIcon } from 'img/social/icon-instagram.svg';
import { ReactComponent as YoutubeIcon } from 'img/social/icon-youtube.svg';
import { ReactComponent as TiktokIcon } from 'img/social/icon-tiktok.svg';
import { useStaticQuery, graphql } from 'gatsby';
import { useGenerateSiteLink } from 'hooks/use-generate-site-link';

const getSocialIcon = (profileType: string) => {
    let icon;

    switch (profileType.toLowerCase()) {
        case 'twitter':
            icon = <XIcon />;
            break;
        case 'facebook':
            icon = <FacebookIcon />;
            break;
        case 'instagram':
            icon = <InstagramIcon />;
            break;
        case 'youtube':
            icon = <YoutubeIcon />;
            break;
        case 'tiktok':
            icon = <TiktokIcon />;
            break;
        case 'linkedin':
            icon = <LinkedInIcon />;
            break;
    }

    return icon;
};

const Footer: React.FC = () => {
    const { datoCmsFooter, datoCmsWebsiteLayout } = useStaticQuery<Queries.FooterQuery>(graphql`
        query Footer {
            datoCmsFooter {
                navigation {
                    link {
                        ...ButtonLinkFields
                    }
                }
                content {
                    heading
                    text {
                        content
                    }
                }
                bottomGlobalNavigation {
                    link {
                        ...ButtonLinkFields
                    }
                }
            }
            datoCmsWebsiteLayout {
                socialProfiles {
                    profileType
                    url
                }
            }
        }
    `);

    return (
        <footer className="site-footer" data-datocms-noindex>
            <div className="site-footer__top">
                <div className="container">
                    <ul role="list" className="footer-nav">
                        {datoCmsFooter?.navigation?.map((footerNavLink, index) => {
                            const linkData = useGenerateSiteLink(footerNavLink?.link ?? null);
                            if (linkData) {
                                return (<li key={index}><a href={linkData.url ?? '#'}>{linkData.label}</a></li>);
                            }
                        })}
                    </ul>
                    <div className="footer-logo">
                        <FullLogo />
                    </div>
                    {datoCmsFooter?.content?.map((footerContent, index) => {
                        if (footerContent?.heading && footerContent.text?.content) {
                            return (
                                <div key={index} className="footer-box">
                                    <div className="footer-box-title h6">{footerContent?.heading}</div>
                                    <div className="rtecontent" dangerouslySetInnerHTML={{__html: footerContent.text.content}} />
                                </div>
                            );
                        }
                    })}
                    {(datoCmsWebsiteLayout?.socialProfiles?.length ?? 0) > 0 &&
                        <div className="footer-box">
                            <div className="footer-box-title h6">Connect</div>
                            <ul role="list" className="footer-social">
                                {datoCmsWebsiteLayout?.socialProfiles?.map((profile, index) =>
                                    <li key={index}>
                                        <a href={profile?.url ?? '#'}>
                                            {getSocialIcon(profile?.profileType ?? '')}
                                            <span className="sr-only">{profile?.profileType}</span>
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                    }
                </div>
            </div>
            <div className="site-footer__bottom">
                <div className="container">
                    <div>
                        <span>&copy;{new Date().getFullYear()} Washington State Fair Event Center, All Rights Reserved.&nbsp;</span>
                        <span><a href="https://www.sitecrafting.com" target="_blank">Website Design and Development by SiteCrafting</a></span>
                    </div>
                    <div className="links">
                        {datoCmsFooter?.bottomGlobalNavigation?.map((globalNavItem, index) => {
                            const linkData = useGenerateSiteLink(globalNavItem?.link ?? null);
                            if (linkData) {
                                return (<a key={index} href={linkData.url ?? '#'}>{linkData.label}</a>);
                            }
                        })}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;